// Video
export const bucketPath = process.env.GATSBY_BUCKET_URL
export const videoPath = process.env.GATSBY_VIDEO_URL
